import type { Meeting } from '@tebuto/api/therapists/models/Meeting'
import { DateTime } from 'luxon'

type SwrGlobalMutate = (
    matcher: (key: unknown) => boolean,
    data?: undefined,
    options?: { revalidate: boolean }
) => Promise<unknown[]>

export function invalidateTherapistMeetingsCache(mutate: SwrGlobalMutate, therapistId: number): Promise<unknown[]> {
    return mutate((key: unknown) => Array.isArray(key) && key[0] === 'meetings' && key[1] === therapistId, undefined, {
        revalidate: true
    })
}

export function meetingOverlapsVisibleRange(
    meeting: Meeting,
    rangeStart: DateTime<true>,
    rangeEnd: DateTime<true>
): boolean {
    const meetingStart = DateTime.fromISO(meeting.start)
    const meetingEnd = DateTime.fromISO(meeting.end)
    if (!meetingStart.isValid || !meetingEnd.isValid) {
        return false
    }
    return meetingEnd >= rangeStart && meetingStart <= rangeEnd
}
